import React from "react";

export default function StatPill({ label, value, tone = "default" }) {
  const normalizedTone = String(tone || "default").trim().toLowerCase();
  const toneClassByKey = {
    warning: "gg-stat-pill gg-stat-pill--warning",
    info: "gg-stat-pill gg-stat-pill--info",
    error: "gg-stat-pill gg-stat-pill--error",
    scheduled: "gg-stat-pill gg-stat-pill--scheduled",
    success: "gg-stat-pill gg-stat-pill--success",
    highlight: "gg-stat-pill gg-stat-pill--highlight"
  };
  const toneClass = toneClassByKey[normalizedTone] || "gg-stat-pill";

  return (
    <div className={toneClass}>
      <span className="gg-stat-pill__label">{label}</span>
      <span className="gg-stat-pill__value">{value}</span>
    </div>
  );
}
